import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const InfoIcon = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 22 22"
        fill="none"
      >
        <path
          d="M11 0.250487C16.93 0.250488 21.75 5.07049 21.75 11.0005C21.75 16.9305 16.93 21.7505 11 21.7505C5.07 21.7505 0.25 16.9305 0.250001 11.0005C0.250001 5.07049 5.07 0.250487 11 0.250487ZM11 20.2505C16.1 20.2505 20.25 16.1005 20.25 11.0005C20.25 5.90049 16.1 1.75049 11 1.75049C5.9 1.75049 1.75 5.90049 1.75 11.0005C1.75 16.1005 5.9 20.2505 11 20.2505Z"
          fill={color}
        />
        <path
          d="M11 9.25049C11.41 9.25049 11.75 9.59049 11.75 10.0005L11.75 15.0005C11.75 15.4105 11.41 15.7505 11 15.7505C10.59 15.7505 10.25 15.4105 10.25 15.0005L10.25 10.0005C10.25 9.59049 10.59 9.25049 11 9.25049Z"
          fill={color}
        />
        <path
          d="M11 6.00049C11.13 6.00049 11.26 6.03049 11.38 6.08049C11.5 6.13049 11.61 6.20049 11.71 6.29049C11.8 6.39049 11.87 6.49049 11.92 6.62049C11.97 6.74049 12 6.87049 12 7.00049C12 7.13049 11.97 7.26049 11.92 7.38049C11.87 7.50049 11.8 7.61049 11.71 7.71049C11.61 7.80049 11.5 7.87049 11.38 7.92049C11.14 8.02049 10.86 8.02049 10.62 7.92049C10.5 7.87049 10.39 7.80049 10.29 7.71049C10.2 7.61049 10.13 7.50049 10.08 7.38049C10.03 7.26049 10 7.13049 10 7.00049C10 6.87049 10.03 6.74049 10.08 6.62049C10.13 6.49049 10.2 6.39049 10.29 6.29049C10.39 6.20049 10.5 6.13049 10.62 6.08049C10.74 6.03049 10.87 6.00049 11 6.00049Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default InfoIcon;
